import { z } from 'zod';

import { displayNameField, emailField, loginField, newPasswordField } from '@/entities/viewer';

export const loginSchema = z.object({
  login: z.string().trim().min(1, 'REQUIRED'),
  password: z.string().min(1, 'REQUIRED'),
});
export type LoginValues = z.infer<typeof loginSchema>;

export const registerSchema = z.object({
  login: loginField,
  email: emailField,
  display_name: displayNameField,
  password: newPasswordField,
});
export type RegisterValues = z.infer<typeof registerSchema>;
